import { io } from "socket.io-client";

// "undefined" means the URL will be computed from the `window.location` object
let URL = undefined;

if (
  window.location.href.includes("localhost:5009") ||
  window.location.href.includes("onlyfy.talentbait.de")
) {
  URL = "https://app.talentbait.de";
}

export const socket = io(URL, {
  transports: ["websocket"]
});
